export class EchantillonMouvementEdition {
    static jsonMap = {
        id: { key: 'id', optional: true },
        numeroLot: { key: 'numeroLot', optional: true, default: '' },
        numeroDossier: { key: 'numeroDossier', optional: true, default: '' },
        cepage: { key: 'cepage', optional: true },
        volume: { key: 'volume', optional: true, default: '' },
        type: { key: 'type', optional: true, default: '' },
        logement: { key: 'logement', optional: true, default: '' },
        contenant: { key: 'contenant', optional: true, default: '' },
        date: { key: 'date', optional: true, default: '' },
        dateRetiraison: { key: 'dateRetiraison', optional: true, default: '' },
        typeConditionnement: { key: 'typeConditionnement', optional: true, default: '' },
        qteRestanteStock: { key: 'qteRestanteStock', optional: true, default: '' },
        degre: { key: 'degre', optional: true, default: '' }
    };

    id: number;
    numeroLot: string;
    numeroDossier: string;
    cepage: number;
    volume: string;
    type: string;
    logement: string;
    contenant: string;
    date: string;
    dateRetiraison: string;
    typeConditionnement: string;
    qteRestanteStock: string;
    degre: string;
}
